export default __webpack_public_path__ + "static/media/values-mobile.0b985dd2.svg";